import React from 'react';

function Footer(props) {
const d = new Date()
let yearCurrent = d.getFullYear()
    return (
        <React.Fragment>
            <div className="footer">
                <div className="copyright">
                    <p>
                       © {yearCurrent} Crewmates, LLC. All Rights Reserved.
                        {/* Copyright © Designed &amp; Developed by
                        <a href="https://www.smartdatainc.com/" target="_blank"></a>
                        2021 */}
                    </p>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Footer;
